import { render, staticRenderFns } from "./PresupuestoList.vue?vue&type=template&id=2ae97e54&scoped=true&"
import script from "./PresupuestoList.vue?vue&type=script&lang=js&"
export * from "./PresupuestoList.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestoList.vue?vue&type=style&index=0&id=2ae97e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae97e54",
  null
  
)

export default component.exports